module.exports = __webpack_public_path__ + "fonts/Roboto-Light-webfont.816d43bc.woff";